jQuery('document').ready(function(){

    moveElementsPerDevice();

   if(jQuery('.template-product').length) {

        jQuery('.qtyHolder .icon-minus').click(function() {

            var curQty = parseInt(jQuery('#Quantity-product-template').val());

            if(curQty > 1) {
                curQty--;
                jQuery('#Quantity-product-template').val(curQty);
            }
        })

        jQuery('.qtyHolder .icon-plus').click(function() {
            var curQty = parseInt(jQuery('#Quantity-product-template').val());
            curQty++;
            jQuery('#Quantity-product-template').val(curQty);
        })

         /** Mobile PDP **/

        if(jQuery(window).width() < 749) {
            jQuery('.grid.product-single').prepend(jQuery('.titleHolder'));
            jQuery('.product-single__meta').prepend(jQuery('.titleHolder .rightPart p').addClass('artist-name')); 


            jQuery('.product-single__description').insertAfter(jQuery('.product-single__meta .product__price')); 

            jQuery('.product-form__controls-group .rightInfoBlock').insertAfter(jQuery('.product-form-product-template')); 
            

            jQuery('.product-single__media-group .left-silder').click(function(e){
                e.preventDefault();
                var currentItem = jQuery('.product-single__thumbnails .product-single__thumbnails-item .active-thumb');

                currentItem.removeClass('active-thumb');

                var currentIndex = jQuery( ".product-single__thumbnails .product-single__thumbnails-item " ).index( currentItem.parent() );


                jQuery('.product-single__media-group .product-single__media-wrapper').eq(currentIndex).addClass('hide');


                if(currentIndex === 0) {
                    currentIndex = jQuery( ".product-single__thumbnails .product-single__thumbnails-item " ).length - 1;
                } else {
                    currentIndex--;
                }

                jQuery('.product-single__media-group .product-single__media-wrapper').eq(currentIndex).removeClass('hide');


                jQuery( ".product-single__thumbnails .product-single__thumbnails-item " ).eq(currentIndex).find('a').addClass('active-thumb');

            })

            jQuery('.product-single__media-group .right-silder').click(function(e){
                e.preventDefault();
                var currentItem = jQuery('.product-single__thumbnails .product-single__thumbnails-item .active-thumb');

                currentItem.removeClass('active-thumb');

                var currentIndex = jQuery( ".product-single__thumbnails .product-single__thumbnails-item " ).index( currentItem.parent() );

                jQuery('.product-single__media-group .product-single__media-wrapper').eq(currentIndex).addClass('hide');


                if(currentIndex === jQuery( ".product-single__thumbnails .product-single__thumbnails-item " ).length - 1) {
                    currentIndex = 0;
                } else {
                    currentIndex++;
                }

                jQuery('.product-single__media-group .product-single__media-wrapper').eq(currentIndex).removeClass('hide');


                jQuery( ".product-single__thumbnails .product-single__thumbnails-item " ).eq(currentIndex).find('a').addClass('active-thumb');

            })

        }

        jQuery('.detailsHolder .plus-minus-button').click(function(){
            jQuery(this).toggleClass('clicked')
            jQuery(this).parent().toggleClass('clicked')
            jQuery(this).parent().next().toggleClass('clicked')
        })

        /** Tablet PDP **/

        if(jQuery(window).width() > 750 && jQuery(window).width() < 1025 ) {
            jQuery('.product-form__controls-group .rightInfoBlock').insertAfter(jQuery('.product-form-product-template'));
            jQuery('.product-single__description').insertAfter(jQuery('.product-single__meta .product__price'));  
        }

   }

    /** PLP **/
    if(jQuery('.template-collection').length) {
        
        if(jQuery('#colInfo').attr('data-collection-json')) {
            //check if current collectino have -artist in rules
            var isArtist = false;
            var obj = jQuery.parseJSON( jQuery('#colInfo').attr('data-collection-json') );
            if(obj.rules) {
                obj.rules.forEach(element => {
                    if(element.condition.includes('artist-')) {
                        isArtist = true;
                    }
                });

                // Just commenting these lines by the request of the client. 
                // The issue: Banner has conflicted margins, rounded border and black text on the center. Client didn't like it.
                // if(isArtist) {
                //     jQuery('.collection-header').addClass('artist-header').append('<h1>' + obj.title + '</h1>');
                // }
            }
        }
    }

    if($('.template-cart').length) {

        $('body').on('click', '.product-recommendations__inner #add_to_cart', function(e) {

            e.preventDefault();

            var pId = $(this).parent().find('input[name="id"').attr('value')

            if(pId.length > 0 ) {
                data = {
                    "id": pId,
                    "quantity": 1
                  }
    
                  jQuery.ajax({
                    type: 'POST',
                    url: '/cart/add.js',
                    data: data,
                    dataType: 'json',
                    success: function() { 
                        document.location.reload();
                    }
                  });
            }

        })

    }

    
   if(jQuery('.template-index').length && jQuery(window).width() < 769) {
        jQuery('.collection-wrapper .collection-view-all-wrapper.collectionCTA a').text('Shop More Cards');
   }

   if ( jQuery('.template-index').length && window.location.href.indexOf("newsletter&form_type=customer") > -1 && $('.alreadySub').length ) {
    $('.alreadySub').show();
   } else {
    $('.alreadySub').hide();
   }


   if(jQuery('.template-collection').length) {
   /* migrate filters from current filter to side filter*/

   var checkExist = setInterval(function() {
        if ($('.boost-pfs-filter-option-emotional').length) {
           // moveFiltersToSideFilter();
            moveFiltersToTopFilter();
            clearInterval(checkExist);
        }
    }, 100);


   $('body').on('click', '.sideFilterInner.Recipient .filterContainer a', function(e) {
       e.preventDefault();

       let currentFilterName = $(this).text();

       if($(this).hasClass('all')) {
           $('.sideFilterInner.Recipient .filterContainer a').removeClass('active');
           $(this).addClass('active');
       } else {
        $('.sideFilterInner.Recipient .filterContainer a.all').removeClass('active');

        if($(this).hasClass('active')) {
            $(this).removeClass('active')
            if($('.sideFilterInner.Recipient .filterContainer a.active').length === 0) {
                $('.sideFilterInner.Recipient .filterContainer a.all').addClass('active');
            }
        } else {
            $(this).addClass('active');
        }

            $('.boost-pfs-filter-option-recipient-new .boost-pfs-filter-option-item .boost-pfs-filter-option-value').each(function() {
                if($(this).text() == currentFilterName) {
                    $(this).parent().click();
                }  
            })

       }

       
   })

   $('body').on('click', '.boost-pfs-filter-apply-button, .boost-pfs-filter-clear', function(){
      setTimeout( function() {
        moveFiltersToTopFilter();
      }, 2000);
   })

   $('body').on('click', '.sideFilterInner.Theme .filterContainer a', function(e) {
    e.preventDefault();

    let currentFilterName = $(this).text();

    if($(this).hasClass('all')) {
        $('.sideFilterInner.Theme .filterContainer a').removeClass('active');
        $(this).addClass('active');
    } else {
     $('.sideFilterInner.Theme .filterContainer a.all').removeClass('active');

        if($(this).hasClass('active')) {
            $(this).removeClass('active')
            if($('.sideFilterInner.Theme .filterContainer a.active').length === 0) {
                $('.sideFilterInner.Theme .filterContainer a.all').addClass('active');
            }
        } else {
            $(this).addClass('active');
        }

         $('.boost-pfs-filter-option-theme .boost-pfs-filter-option-item .boost-pfs-filter-option-value').each(function() {
             if($(this).text() == currentFilterName) {
                 $(this).parent().click();
             }  
         })

    }



    
   })

   $('body').on('click', '.bottomFiltersHolder .filterHolder .filterLabel', function() {
      
      if(jQuery(window).width() < 750) {

        $('.boost-pfs-filter-tree-mobile-button.has-filter button').click();

      }
       /*$('.side-filter').show();
       $('html, body').animate({scrollTop: '0px'}, 0);*/
   })

   $('body').on('click', '.side-filter .filterClose', function() {
    $('.side-filter').hide();
   })

   Filter.prototype.afterRender = function() { 
	var data = this.data; 
      $('.filters-toolbar__product-count').text(data.total_product + ' products');
      setTimeout( function() {
        insertBannersForCOllection();
      }, 1000);
   }

   $('body').on('click', '.filterSubmit', function() {

       if(!$('.sideFilterInner.Recipient .all').hasClass('active')) {
        $('.boost-pfs-filter-option-recipient-new .boost-pfs-filter-apply-button').click();
        $('.side-filter').hide();
       } else {
        $('.boost-pfs-filter-option-recipient-new .boost-pfs-filter-option-item').each(function() {
            if($(this).hasClass('selected')) {
                $(this).find('button').click();
            }  
        })
        $('.boost-pfs-filter-option-recipient-new .boost-pfs-filter-apply-button').click();
        $('.side-filter').hide();
       }

       if(!$('.sideFilterInner.Theme .all').hasClass('active')) {
        $('.boost-pfs-filter-option-theme .boost-pfs-filter-apply-button').click();
        $('.side-filter').hide();
       } else {
        $('.boost-pfs-filter-option-theme .boost-pfs-filter-option-item').each(function() {
            if($(this).hasClass('selected')) {
                $(this).find('button').click();
            }  
        })
        $('.boost-pfs-filter-option-theme .boost-pfs-filter-apply-button').click();
        $('.side-filter').hide();
       }

       setTimeout( function() {
         moveFiltersToTopFilter();
       }, 2000);
   })

   $('body').on('click', '.filterClear', function(){
       $('.boost-pfs-filter-refine-by .boost-pfs-filter-clear-all').click();

       $('.topFilterHolder .top-filters a').removeClass('active');
       $('.topFilterHolder .top-filters a.all').addClass('active');

       $('.sideFilterInner.Recipient .filterContainer a').removeClass('active');
       $('.sideFilterInner.Recipient .filterContainer a.all').addClass('active');
       $('.sideFilterInner.Theme .filterContainer a').removeClass('active');
       $('.sideFilterInner.Theme .filterContainer a.all').addClass('active');
       
       setTimeout( function() {
        moveFiltersToTopFilter();
        moveFiltersToSideFilter();

        $('.filters-toolbar__product-count').text($('#Collection .grid__item').length + ' products'); 
        }, 1000);
   })

   

   $('body').on('click', '.sideFilterInner.Recipient .filterCollapse img', function(){
        $('.sideFilterInner.Recipient .filterContainer').toggle();
        $('.sideFilterInner.Recipient img.plus').toggle();
   });

   $('body').on('click', '.sideFilterInner.Theme .filterCollapse img', function(){
        $('.sideFilterInner.Theme .filterContainer').toggle();
        $('.sideFilterInner.Theme img.plus').toggle();
    });

   $('body').on('click', '.topFilterHolder .top-filters a', function(e){
    
    e.preventDefault();

    let currentFilterName = $(this).text();

    if($(this).hasClass('all')) {
        $('.topFilterHolder .top-filters a').removeClass('active');

        $('.boost-pfs-filter-option-emotional .boost-pfs-filter-option-item').each(function() {
            if($(this).hasClass('selected')) {
                $(this).find('button').click();
            }  
        })
        $(this).addClass('active');
        
    } else {
     $('.topFilterHolder .top-filters a.all').removeClass('active');

        if($(this).hasClass('active')) {
            $(this).removeClass('active')
            if($('.topFilterHolder .top-filters a.active').length === 0) {
                $('.topFilterHolder .top-filters a.all').addClass('active');
            }
        } else {
            $(this).addClass('active');
        }

         $('.boost-pfs-filter-option-emotional .boost-pfs-filter-option-item .boost-pfs-filter-option-value').each(function() {
             if($(this).text() == currentFilterName) {
                 $(this).parent().click();
             }  
         })

    }

        $('.boost-pfs-filter-option-emotional .boost-pfs-filter-apply-button').click();

        /*
        setTimeout( function() {
            moveFiltersToSideFilter();
        }, 1000);*/

   })

   }

})

function moveFiltersToSideFilter() {
    var url_vars = getQueryParams();
    
    $('.sideFilterInner.Recipient .filterContainer').html('');
    $('.sideFilterInner.Theme .filterContainer').html('');

    $('.sideFilterInner.Recipient .filterContainer').append( '<a href="#" class="active all">All</a>' );

    $('.sideFilterInner.Theme .filterContainer').append( '<a href="#" class="active all">All</a>' );

    $('.boost-pfs-filter-option-recipient-new .boost-pfs-filter-option-item-list li .boost-pfs-filter-option-value').each(function(){
        let tempText = $(this).text().replace(' ','+');
        let activeClass = '';
        if(url_vars && url_vars['pf_t_recipient_new'] !== undefined && url_vars['pf_t_recipient_new'].indexOf(tempText) !== -1) {
            activeClass = 'class="active";'
            $('.sideFilterInner.Recipient .filterContainer a.all').removeClass('active')
        }
        $('.sideFilterInner.Recipient .filterContainer').append( '<a href="#" '+ activeClass +'>' + $(this).text() + '</a>' );
    })

    $('.boost-pfs-filter-option-theme .boost-pfs-filter-option-item-list li .boost-pfs-filter-option-value').each(function(){
        let tempText = $(this).text().replace(' ','+');
        let activeClass = '';
        if(url_vars && url_vars['pf_t_theme'] !== undefined && url_vars['pf_t_theme'].indexOf(tempText) !== -1) {
            activeClass = 'class="active";'
            $('.sideFilterInner.Theme .filterContainer a.all').removeClass('active')
        }
        $('.sideFilterInner.Theme .filterContainer').append( '<a href="#" '+ activeClass +'>' + $(this).text() + '</a>' );
    })


}

function moveFiltersToTopFilter() {
    
    var url_vars = getQueryParams();

    console.log(url_vars);

    $('.topFilterHolder .top-filters').html('');

    $('.topFilterHolder .top-filters').append( '<a href="#" class="active all">All</a>' );

    $('.boost-pfs-filter-option-emotional .boost-pfs-filter-option-item-list li .boost-pfs-filter-option-value').each(function(){
        let tempText = $(this).text().replace(' ','+');
        let activeClass = '';
        console.log(tempText)
        if(url_vars &&  url_vars['pf_t_emotional'] !== undefined && url_vars['pf_t_emotional'].indexOf(tempText) !== -1) {
            activeClass = 'class="active";'
            $('.topFilterHolder .top-filters a.all').removeClass('active')
        }
        $('.topFilterHolder .top-filters').append( '<a href="#" '+ activeClass +'>' + $(this).text() + '</a>' );
    });

}

function insertBannersForCOllection() {

    var currentUrl = window.location.href;

    if(jQuery(window).width() > 750) {

        if(currentUrl.includes('page=2')) {
            if(jQuery('.banners_holder .baner4').length && jQuery('.grid--view-items .grid__item').length > 4) {
                jQuery('.banners_holder .baner4').clone().insertAfter(jQuery('.grid--view-items .grid__item').eq(5));
            }
    
                if(jQuery('.banners_holder .baner5').length && jQuery('.grid--view-items .grid__item').length > 13) {
                    jQuery('.banners_holder .baner5').clone().insertAfter(jQuery('.grid--view-items .grid__item').eq(14));
                }
        
                if(jQuery('.banners_holder .baner6').length && jQuery('.grid--view-items .grid__item').length > 26) {
                    jQuery('.banners_holder .baner6').clone().insertAfter(jQuery('.grid--view-items .grid__item').eq(27));
                }
        } else if(currentUrl.includes('page=3')) {
            if(jQuery('.banners_holder .baner7').length && jQuery('.grid--view-items .grid__item').length > 4) {
                jQuery('.banners_holder .baner7').clone().insertAfter(jQuery('.grid--view-items .grid__item').eq(5));
            }
    
                if(jQuery('.banners_holder .baner8').length && jQuery('.grid--view-items .grid__item').length > 13) {
                    jQuery('.banners_holder .baner8').clone().insertAfter(jQuery('.grid--view-items .grid__item').eq(14));
                }
        } else {
            if(jQuery('.banners_holder .baner1').length && jQuery('.grid--view-items .grid__item').length > 4 && !jQuery('.baner_item.baner1 img').is(':visible')) {
                jQuery('.banners_holder .baner1').clone().insertAfter(jQuery('.grid--view-items .grid__item').eq(5));
            }
    
                if(jQuery('.banners_holder .baner2').length && jQuery('.grid--view-items .grid__item').length > 13 && !jQuery('.baner_item.baner2 img').is(':visible')) {
                    jQuery('.banners_holder .baner2').clone().insertAfter(jQuery('.grid--view-items .grid__item').eq(14));
                }
        
                if(jQuery('.banners_holder .baner3').length && jQuery('.grid--view-items .grid__item').length > 26 && !jQuery('.baner_item.baner3 img').is(':visible')) {
                    jQuery('.banners_holder .baner3').clone().insertAfter(jQuery('.grid--view-items .grid__item').eq(27));
                }
        }



    } else {


        if(currentUrl.includes('page=2')) {
            if(jQuery('.banners_holder .baner4').length && jQuery('.grid--view-items .grid__item').length > 2  && !jQuery('.baner_item.baner4 img').is(':visible')) {
                jQuery('.banners_holder .baner4').clone().insertAfter(jQuery('.grid--view-items .grid__item').eq(3));
            }

    
                if(jQuery('.banners_holder .baner5').length && jQuery('.grid--view-items .grid__item').length > 7  && !jQuery('.baner_item.baner5 img').is(':visible')) {
                    jQuery('.banners_holder .baner5').clone().insertAfter(jQuery('.grid--view-items .grid__item').eq(8));
                }
    
                if(jQuery('.banners_holder .baner6').length && jQuery('.grid--view-items .grid__item').length > 12  && !jQuery('.baner_item.baner6 img').is(':visible')) {
                    jQuery('.banners_holder .baner6').clone().insertAfter(jQuery('.grid--view-items .grid__item').eq(13));
                }
            
        } else if(currentUrl.includes('page=3')) {
            if(jQuery('.banners_holder .baner7').length && jQuery('.grid--view-items .grid__item').length > 2  && !jQuery('.baner_item.baner7 img').is(':visible')) {
                jQuery('.banners_holder .baner7').clone().insertAfter(jQuery('.grid--view-items .grid__item').eq(3));
            }
    
    
                if(jQuery('.banners_holder .baner8').length && jQuery('.grid--view-items .grid__item').length > 7  && !jQuery('.baner_item.baner8 img').is(':visible')) {
                    jQuery('.banners_holder .baner8').clone().insertAfter(jQuery('.grid--view-items .grid__item').eq(8));
                }
        } else {
            if(jQuery('.banners_holder .baner1').length && jQuery('.grid--view-items .grid__item').length > 2 && !jQuery('.baner_item.baner1 img').is(':visible')) {
                jQuery('.banners_holder .baner1').clone().insertAfter(jQuery('.grid--view-items .grid__item').eq(3));
            }
    
    
                if(jQuery('.banners_holder .baner2').length && jQuery('.grid--view-items .grid__item').length > 7 && !jQuery('.baner_item.baner2 img').is(':visible')) {
                    jQuery('.banners_holder .baner2').clone().insertAfter(jQuery('.grid--view-items .grid__item').eq(8));
                }
    
                if(jQuery('.banners_holder .baner3').length && jQuery('.grid--view-items .grid__item').length > 12 && !jQuery('.baner_item.baner3 img').is(':visible')) {
                    jQuery('.banners_holder .baner3').clone().insertAfter(jQuery('.grid--view-items .grid__item').eq(13));
                }
        }



    }
}

function moveElementsPerDevice() {
    if(jQuery(window).width() < 749) {
        jQuery('.site-header .grid__item.logo-align--left').prepend($('.site-header .site-header__menu'));

    } else {
        jQuery('.site-footer__item-inner').eq(3).find('.site-footer__linklist').append($('.copyRightLi'));
    }

}

function getQueryParams () {
    function identity (e) { return e; }
    function toKeyValue (params, param) {
        var keyValue = param.split('=');
        var key = keyValue[0], value = keyValue[1];
        console.log(key);
        params[key] = params[key]?[value].concat(params[key]):value;
        return params;
    }
    return decodeURIComponent(window.location.search).
        replace(/^\?/, '').split('&').
        filter(identity).
        reduce(toKeyValue, {});
}